$(document).ready(function () {
  function renderSelect2() {
    let locationSelect = $(document).find('.js-location-select')
    if (locationSelect.length) {
      locationSelect.select2({
        placeholder: "Location",
        minimumResultsForSearch: -1
      })

      let modal = $(document).find('.js-filter-modal')

      locationSelect.on('select2:open', function (e) {
        modal.hasClass('show') && $(document).find('.select2-container').addClass('select2-container--on-modal')
      });
      locationSelect.on('select2:close', function (e) {
        $(document).find('.select2-container').removeClass('select2-container--on-modal')
      });
    }

    let sortBySelect = $(document).find('.js-sort-by-select')
    if (sortBySelect.length) {
      sortBySelect.select2({
        placeholder: "All",
        minimumResultsForSearch: -1
      })
    }

    let bottomNavShowSelect = $(document).find('.js-bottom-nav-show-select')
    if (bottomNavShowSelect.length) {
      bottomNavShowSelect.select2({
        placeholder: "All",
        minimumResultsForSearch: -1
      })
    }
  }

  function sidebarFormDuplication() {
    let form = $(document).find('.js-sidebar-form')
    let modal = $(document).find('.js-filter-modal')

    if (form.length && modal.length) {
      let modalBody = modal.find('.modal-body')
      let childrenToMove = form.children('*:not(:first-child)')

      modal.on('show.bs.modal', (_) => {
        childrenToMove.appendTo(modalBody)
      })

      modal.on('hidden.bs.modal', (_) => {
        childrenToMove.appendTo(form)
      })
    }
  }

  function init() {
    renderSelect2()
    sidebarFormDuplication()
  }

  init()
})